module.exports = __webpack_public_path__ + "assets/img/sabc_video_pic.webp?8359ed3f112e211236dd7db894c7faf0";